import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CheckPermissions, GetQuery, PostQuery } from './Shared';

const AdminReckonData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [dunnyFilename, setDunnyFilename] = React.useState("");
    const [scaffoldFilename, setScaffoldFilename] = React.useState("");

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("UpdateReckonFilename");
        if (hasPermission) {
            getReckonData();
        } else {
            navigate("/accessdenied");
        }
    }

    const getReckonData = async () => {
        const apiUrl = "GetAdminReckonData";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setDunnyFilename(result.data.dunnyFilename);
            setScaffoldFilename(result.data.scaffoldFilename);
            setLoading(false);
        }
    }

    const clearError = (errorName: string) => {
        var errorList = errors;
        if (errorName) {
            delete errorList[errorName];
            setErrors(errorList);
        }
    }

    const handleDunnyFilenameChange = (e: any) => {
        clearError(e.target.name);
        setDunnyFilename(e.target.value);
    }

    const handleScaffoldFilenameChange = (e: any) => {
        clearError(e.target.name);
        setScaffoldFilename(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!dunnyFilename || dunnyFilename.length === 0) {
            errorList["dunnyFilename"] = "Please enter the filename for Dunny Reckon!";
            formIsValid = false;
        }

        if (!scaffoldFilename || scaffoldFilename.length === 0) {
            errorList["scaffoldFilename"] = "Please enter the filename for Scaffold Reckon!";
            formIsValid = false;
        }
        
        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            saveReckonData();
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const saveReckonData = async () => {
        var reckonData = {
            dunnyFilename: dunnyFilename,
            scaffoldFilename: scaffoldFilename
        };

        var jsonItem = JSON.stringify(reckonData);

        const apiUrl = "SaveReckonData";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Reckon Data Saved Successfully");
                setErrors({});
            }
        }
    }

    const renderDetails = (
        <div>
            <label className="input-group" htmlFor="dunnyFilename">
                <span className="label">Reckon Dunny filename</span>
                <input className="input" type="text" id="dunnyFilename" name="dunnyFilename" value={dunnyFilename} onChange={(e) => handleDunnyFilenameChange(e)}></input>
            </label>
            <span className={errors["dunnyFilename"] ? "label errors marginLeftLabel" : "hidden"}>{errors["dunnyFilename"]}</span>

            <label className="input-group" htmlFor="scaffoldFilename">
                <span className="label">Reckon Scaffold filename</span>
                <input className="input" type="text" id="scaffoldFilename" name="scaffoldFilename" value={scaffoldFilename} onChange={(e) => handleScaffoldFilenameChange(e)}></input>
            </label>
            <span className={errors["scaffoldFilename"] ? "label errors marginLeftLabel" : "hidden"}>{errors["scaffoldFilename"]}</span>
            
            <div className="marginBottom10">
                <button className="defaultbutton marginLeftLabel" type="button" onClick={save} disabled={loading ? true : false}>Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Reckon Data</h1>
            {contents}
        </div>
    );
}

export default AdminReckonData;